































































































import Vue from 'vue';
import VClamp from 'vue-clamp';
import HMTag from '@/web/components/common/HMTag.vue';
import HMInstructorsStack from '@/web/components/common/HMInstructorsStack.vue';
import { mapGetters } from 'vuex';
import { formatDate } from '@/web/utils/format';
import { renderHtmlFromEditorJS } from '@/core/utils/utils';
import MediaThumbnail from '@/web/components/products/MediaThumbnail.vue';

export default Vue.extend({
  name: 'StudioLessonMediaCard',
  components: { VClamp, HMTag, HMInstructorsStack, MediaThumbnail },
  props: {
    media: {
      type: Object as () => ProductMediaResponse,
      required: true,
    },
    hasAccess: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
      canViewProductContent: 'product/canViewProductContent',
      cantViewProductContentReason: 'product/cantViewProductContentReason',
      mediaIconsEnabled: 'studio/mediaIconsEnabled',
    }),
    getCantViewProductReasonText() {
      if (this.canViewProductContent) return null;
      switch (this.cantViewProductContentReason) {
        case 'unauthenticated':
          return this.$t(
            'PRODUCTS.TEXT.PRODUCT_NO_ACCESS_USER_NOT_AUTHENTICATED'
          );
        case 'not_purchased':
          return this.$t('PRODUCTS.TEXT.PRODUCT_NO_ACCESS_NOT_PURCHASED');
        case 'availability_expired':
          return this.$t('PRODUCTS.TEXT.PRODUCT_NO_ACCESS_EXPIRED', {
            date: formatDate(
              this.product.can_view_content.end_date,
              'date-time'
            ),
          });
        case 'drip_expired':
          return this.$t('PRODUCTS.TEXT.PRODUCT_NO_ACCESS_EXPIRED', {
            date: formatDate(
              this.product.can_view_content.end_date,
              'date-time'
            ),
          });
        case 'not_yet_available':
          return this.$t('PRODUCTS.TEXT.PRODUCT_NO_ACCESS_NOT_YET_AVAILABLE', {
            date: formatDate(
              this.product.can_view_content.start_date,
              'date-time'
            ),
          });
      }
      return '';
    },
    getMediaTags() {
      const mediaOptionsArray = this.media.options.slice();
      return mediaOptionsArray.splice(0, 2);
    },
    getCutOffMediaTagsHtml() {
      const mediaOptionsArray = this.media.options.slice();
      return mediaOptionsArray
        .splice(2)
        .map(option => option.option_name)
        .join('<br/>');
    },
    getRemainingMediaTagsText() {
      if (this.media.options.length < 3) return null;
      return `+ ${this.media.options.length - 2}`;
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    strip(html, json) {
      let useHtml = html;
      if (json) {
        useHtml = renderHtmlFromEditorJS(json);
      }

      const doc = new DOMParser().parseFromString(useHtml, 'text/html');
      return doc.body.textContent || '';
    },
  },
});
